import { render, staticRenderFns } from "./PropLikesTotal.vue?vue&type=template&id=20c6aa5e&"
import script from "./PropLikesTotal.vue?vue&type=script&lang=js&"
export * from "./PropLikesTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports